import { Portal } from "@mantine/core";
import { Navigate, Outlet, useLocation } from "react-router";
import { SubnavSystems } from "./components/subnav-systems";

export const SystemsPage = () => {
  const { pathname } = useLocation();

  if (pathname === "/systems") {
    return <Navigate to="/systems/applications" />;
  }

  return (
    <>
      <Portal target="#subnav">
        <SubnavSystems />
      </Portal>
      <Outlet />
    </>
  );
};
